import { useSearchParams } from 'react-router-dom';
import { BottleneckAnalysis } from '@/components/analytics/BottleneckAnalysis';

const DEFAULT_FROM = (() => {
  const d = new Date();
  d.setDate(d.getDate() - 30);
  return d.toISOString().split('T')[0];
})();
const DEFAULT_TO = new Date().toISOString().split('T')[0];

export function HealthView() {
  const [searchParams] = useSearchParams();
  const dateFrom  = searchParams.get('from')      ?? DEFAULT_FROM;
  const dateTo    = searchParams.get('to')         ?? DEFAULT_TO;
  const highlight = searchParams.get('highlight')  ?? undefined;

  return <BottleneckAnalysis dateFrom={dateFrom} dateTo={dateTo} highlightId={highlight} />;
}
